<template>
  <w-picker
    ref="picker"
    class="room-picker"
    :aria-label="ariaLabel"
    :label="roompickerTitle"
    @click="handleClick"
  ></w-picker>
</template>

<script>
import i18n from '../i18n';
import Picker from './common/Picker.vue';
import ListSelect from './common/ListSelect.vue';

export default {
  components: {
    'w-picker': Picker,
  },
  props: ['state'],
  computed: {
    ariaLabel: function () {
      return i18n.sprintf(
        i18n.gettext('Room picker. Current room: %s'),
        this.selectedRoomPickerOption.title
      );
    },
    roomOptions: function () {
      return this.state.roomPickerOptions();
    },
    selectedRoomPickerOption: function () {
      return this.roomOptions.find(
        (option) => option.id === this.state.formValues.resourceGroup
      );
    },
    roomSelectOptions: function () {
      return this.state.roomPickerOptions();
    },
    roompickerTitle: function () {
      return this.selectedRoomPickerOption.title;
    },
  },
  methods: {
    handleClick() {
      const roomModalRef = this.$modal.open({
        parent: this.$parent,
        component: ListSelect,
        props: {
          options: this.roomSelectOptions,
          state: this.state,
          ariaLabel: i18n.gettext('Room-picker modal. Press Escape to exit.'),
        },
        events: {
          select: this.handleRoomSelect,
        },
        customClass: `roompicker-modal ${this.state.widgetStyle}`,
        canCancel: ['escape', 'outside'],
      });
      this.roomModalRef = roomModalRef;
    },
    handleRoomSelect: function ({ id }) {
      this.state.formValues.resourceGroup = id;
      this.state.getAvailabilities({ resource_group: id });
      this.roomModalRef.close();

      // Restore focus after closing the modal
      this.$nextTick(() => {
        this.$refs.picker?.restoreFocus();
      });
    },
  },
};
</script>

<style lang="scss">
@import '../styles/_variables.scss';

.room-picker {
  position: sticky;
  border-color: var(--theme-font-color-opacity-5);
  width: 100%;
  background: var(--theme-background-color);

  @at-root #{$broadway} & {
    border: none;

    .icon-left {
      margin-left: 2%;
    }
    .icon-right {
      margin-right: 2%;
    }
  }

  @at-root #{$glass} & {
    background: transparent;
    border: none;

    .icon-container {
      color: var(--theme-accent-color);
      &:not(.icon-disabled):active {
        color: var(--theme-background-color);
      }
    }
    .adjustment-button {
      color: var(--theme-accent-color);
    }
  }
}
.roompicker-modal {
  .modal-background {
    opacity: 0.2;
  }
  .modal-content {
    background: var(--theme-background-color);
    color: var(--theme-font-color);
    max-width: 20rem !important;
    max-height: 25rem;
    border-radius: 10px;
  }
}

.broadway,
.glass {
  .modal-content {
    color: var(--theme-font-color);
    background: var(--theme-background-color) !important;
  }
}
</style>
